export default __webpack_public_path__ + "/dist/images/1265983.129afed7b0da22e244a70de9fdb20538.png";